import React, { useEffect } from "react";

import { Alert } from "react-bootstrap";

import Loader from "./Loader.tsx";
import SelectCreatable from "./SelectCreatable.tsx";
import { Agency } from "../interfaces.ts";

interface ISelectAgencyProps {
  rightValue: string;
  setAgency: (agency: { label: string; value: string, manageErpBillings: boolean }) => void;
  defaultValue?: string;
  agencies?: Agency[];
  loading?: boolean;
  error: any;
}

const SelectAgency: React.FC<ISelectAgencyProps> = ({
  rightValue,
  setAgency,
  defaultValue,
  agencies,
  loading,
  error
}) => {


  useEffect(() => {
    // set default value
    if (agencies && agencies.length > 0) {
      if (defaultValue) {
        const agency = agencies.find(
          (agency: Agency) => agency.id === defaultValue,
        );
        if (agency) {
          setAgency({ value: agency.id, label: agency.label, manageErpBillings: agency.manageErpBillings });
        }
      } else {
        setAgency({ value: agencies[0].id, label: agencies[0].label, manageErpBillings: agencies[0].manageErpBillings });
      }
    }
  }, [agencies]);

  if (loading) {
    return <Loader />;
  }

  if (error) {
    console.log(
      `Error Fetch Agencies rightValue => ${rightValue} :`,
      error.message,
    );
    return <Alert variant="danger">Impossible de récupérer les agences.</Alert>;
  }

  if (!agencies) {
    return (
      <Alert variant="danger">
        Erreur de récupération des données : Veuillez réessayer ultérieurement.
      </Alert>
    );
  }
  if (agencies.length < 1) {
    return <Alert variant="info">Aucune agence trouvée</Alert>;
  }

  return (
    <SelectCreatable
      options={agencies.map((agency: Agency) => {
        return { label: agency.label, value: agency.id, manageErpBillings: agency.manageErpBillings };
      })}
      getValue={(value) => setAgency(value)}
      className={"w-100"}
      isMulti={false}
      creatable={true}
      defaultValue={
        defaultValue
          ? agencies.find((agency: Agency) => agency.id === defaultValue)
          : agencies[0]
      }
    />
  );
};

export default SelectAgency;
